/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Polygon } from 'react-native-svg';

import { IconProps } from '../lib';

function WindowsLogo(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Polygon
        points="216 216 136 201.455 136 201.455 136 144 216 144 216 216"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={12}
      />
      <Polygon
        points="104 195.636 40 184 40 144 104 144 104 195.636"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={12}
      />
      <Polygon
        points="216 40 136 54.545 136 54.545 136 112 216 112 216 40"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={12}
      />
      <Polygon
        points="104 60.364 40 72 40 112 104 112 104 60.364"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={12}
      />
    </Svg>
  );
}

export default WindowsLogo;
